import React from "react";
import Page from "../../components/Page";
import { translations } from "../../config";

/**
 * Komponente um statische Inhalte auszugeben
 */
class Agb extends React.Component
{
	render()
	{
		const { inline = false } = { ...this.props };
		
		const data = <React.Fragment>
			<h3>§ 1 Grundlegende Bestimmungen</h3>
				<p>
					(1) Die vorliegenden Geschäftsbedingungen gelten für von der Test GmbH, Test-Str. 1, 53773 Hennef - nachfolgend Anbieter genannt -
					gegenüber dem Kunden nach diesen vertraglichen Vereinbarungen zu erbringenden Leistungen. Abweichende oder entgegenstehende Geschäfts¬bedingungen
					sind nur mit ausdrücklicher Zustimmung des Anbieters wirksam.
				</p>
				<p>
					(2) Der Anbieter erbringt Leistungen nur gegenüber Unternehmern und juristischen Personen des öffentlichen Rechts. Ein Vertrag mit Verbrauchern ist
					ausgeschlossen. Unternehmer gem. § 14 Abs.1 BGB ist jede natürliche oder juristische Person oder eine rechtsfähige Personengesellschaft, die bei
					Abschluss eines Rechtsgeschäfts in Ausübung ihrer selbständigen beruflichen oder gewerblichen Tätigkeit handelt. Der Anbieter behält sich vor, vom
					Kunden vor Vertragsschluss und während des Bestehens des Vertrages Nachweise für die Unternehmereigenschaft zu verlangen.
				</p>
				<p>
					(3) Vertragssprache ist deutsch. Der vollständige Vertragstext wird beim Anbieter nicht gespeichert. Der Kunde kann den Vertragstext vor Abgabe der
					Bestellung über die Druckfunktion des Browsers ausdrucken oder elektronisch sichern.
				</p>
				<h3>
					§ 2 Leistungsumfang</h3>
				<p>
					(1) Während der Vertragslaufzeit des {translations.de_DE.words.appName} Services stellt der Anbieter dem Kunden im {translations.de_DE.words.appName} Mitgliederbereich die Möglichkeit zur
					Verfügung, Einstufungs-Assistenten zur Richtlinienrecherche zu durchlaufen und ein individuell angepasstes Ergebnis-PDF zu generieren – nachfolgend
					{translations.de_DE.words.appName} Report genannt.
					Dabei räumt der Anbieter dem Kunden das nicht ausschließliche, auf die Vertragsdauer beschränkte, nicht übertragbare Recht ein, die ihm zur
					Verfügung gestellten Ergebnisse für die jeweilige interne Dokumentation des Kunden zu nutzen und diese als Nachweis zur Erfüllung der gesetzlich
					vorgeschriebenen Herstellerpflichten zu archivieren.
				</p>
				<p>
					(2) Der Kunde erhält für die Vertragsdauer im {translations.de_DE.words.appName} Mitgliederbereich die Möglichkeit, über Konfigurationsmasken verschiedene Einstellungen
					vorzunehmen, anhand derer die {translations.de_DE.words.appName} Reports nach den individuellen Gegebenheiten des Kunden generiert werden können. Die {translations.de_DE.words.appName} Reports
					werden im {translations.de_DE.words.appName} Mitgliederbereich zur Verfügung gestellt.
				</p>
				<p>
					(3) Mit dem zur Verfügung stellen der {translations.de_DE.words.appName} Reports ist keine Rechts- bzw. Fachberatung verbunden. Es obliegt dem Kunden selbst, im Einzelfall
					und/oder in Zweifelsfällen fachkundigen Rat beispielsweise über einen Rechtsanwalt bzw. Sachverständigen einzuholen.
				</p>
				<p>
					(4) Der {translations.de_DE.words.appName} Report wird in deutscher Sprache erstellt. Ein Anspruch von {translations.de_DE.words.appName} Reports in verschiedenen Fremdsprachen besteht nicht.
				</p>
				<h3>
					§ 3 Vertragsschluss
				</h3>
				<p>
					Die im Internet angebotenen Leistungen des Anbieters sind verbindlich. Mit dem Abschließen des initialen Registrierungsprozesses über die
					Schaltfläche „Registrieren und kostenpflichtig bestellen“ nimmt der Kunde das Vertragsangebot des Anbieters an. Vertragsleistungen, die eine
					nutzungsabhängige Vergütung nach sich ziehen, bestellt der Kunde über die Schaltfläche „Recherche zahlungspflichtig starten“ verbindlich.
				</p>
				<h3>
					§ 4 Pflichten des Kunden
				</h3>
				<p>
					(1) Die {translations.de_DE.words.appName} Reports dürfen ausschließlich für gewerbliche Zwecke genutzt werden.
				</p>
				<p>
					(2) Der Kunde ist verpflichtet, die Zugangsberechtigung zu seinem Kundenbereich vor unbefugtem Zugriff zu schützen und bei einem unberechtigten
					Zugriff den Anbieter unverzüglich zu unterrichten.
				</p>
				<p>
					(3) Der Kunde ist verpflichtet, bei der Konfiguration des {translations.de_DE.words.appName} Reports alle Abfragen im Einstufungs-Assistenten zutreffend und vollständig zu
					beantworten. Die im Editor zur Verfügung gestellten Freitextfelder dürfen ausschließlich zur Eingabe von Informationen genutzt werden, die an dieser
					Stelle aufgrund der vorhandenen Fragestellung vorgesehen sind. Der Kunde trägt für alle im Editor vorgenommenen Angaben die alleinige Verantwortung,
					der Anbieter hat hierauf keinen Einfluss und keine Kontrollpflichten.
				</p>
				<p>
					(4) Der Kunde ist verpflichtet, die aufgrund seiner Angaben erstellten {translations.de_DE.words.appName} Reports vor der weiteren Verwendung sorgfältig zu lesen und auf
					Vollständigkeit und Schlüssigkeit zu prüfen. Der Kunde hat zudem für Widerspruchsfreiheit zwischen den tatsächlichen Gegebenheiten seines Safety
					Apps Reports und der Beantwortung der Abfragen zu sorgen.
				</p>
				<p>
					(5) Nimmt der Kunde nach dem Zeitpunkt der letzten Generierung des {translations.de_DE.words.appName} Reports Änderungen an seinem Produkt vor oder ändern sich
					Bedingungen, welche Einfluss auf das Produkt haben, ist er verpflichtet, unverzüglich die Konfiguration der {translations.de_DE.words.appName} Reports erneut vorzunehmen.
				</p>
				<h3>
					§ 5 Verwendung der generierten {translations.de_DE.words.appName} Reports
				</h3>
				<p>
					(1) Die {translations.de_DE.words.appName} Reports dürfen ohne Zustimmung des Anbieters weder verändert noch ergänzt werden. Auch Streichungen sind unzulässig. Die Safety
					Apps Reports dürfen nicht anderweitig genutzt oder anderen zum Zweck der Nutzung zur Verfügung gestellt werden. Sie sind ausschließlich für die
					Organisation bzw. das Unternehmen des Kunden bestimmt.
				</p>
				<p>
					(2) Den Kunden trifft die Obliegenheit, seine {translations.de_DE.words.appName} Reports stets aktuell zu halten bzw. neue {translations.de_DE.words.appName} Reports zu generieren. Sofern sich
					der Kunde nicht über Aktualisierungen informiert und/oder nicht die jeweils aktuelle Version verwendet, trägt er das damit verbundene rechtliche
					Risiko.
				</p>
				<h3>
					§ 6 Preise, Zahlungsbedingungen
				</h3>
				<p>
					(1) Die für die jeweiligen Leistungen angeführten Preise sind Nettobeträge. Sie beinhalten nicht die gesetzliche Umsatzsteuer, die zusätzlich zu
					zahlen ist.
				</p>
				<p>
					(2) Es gelten die zum Zeitpunkt des Vertragsschlusses vom Anbieter auf der Webseite veröffentlichten Preise. Soweit die Parteien Sonderkonditionen
					vereinbart haben, gelten diese weder für gleichzeitig laufende noch für zukünftige Vertragsverhältnisse.
				</p>
				<p>
					(3) Soweit für die Leistung auf der Webseite des Anbieters nicht abweichend geregelt, ist die Vergütung monatlich zu entrichten am Ende des
					Kalendermonats. Einmalvergütungen bzw. nutzungsabhängige Vergütungen werden ebenfalls am Monatsende fällig.
				</p>
				<p>
					(4) Sofern der Kunde in Zahlungsverzug gerät, hat der Anbieter Anspruch auf Verzugszinsen in Höhe von 9 Prozentpunkten über dem jeweiligen
					Basiszinssatz. Für die erste Mahnung fallen Bearbeitungskosten in Höhe von 5,00 €, für jede weitere Mahnung in Höhe von 10,00 Euro an, es sei denn der
					Kunde kann den Nachweis führen, dass niedrigere Kosten angefallen sind. Falls Rechnungen überfällig sind, werden, soweit gesetzlich zulässig,
					eingehende Zahlungen zuerst auf eventuelle Kosten und Zinsen und dann auf die älteste Forderung angerechnet.
				</p>
				<p>
					(5) Bei Zahlung per SEPA-Lastschrift ermächtigt der Kunde den Anbieter durch Erteilung eines entsprechenden SEPA-Mandats, den Rechnungsbetrag vom
					angegebenen Konto einzuziehen. Der Einzug der Lastschrift erfolgt innerhalb von 1-5 Tagen nach Rechnungsstellung. Der Kunde ist verpflichtet für die
					ausreichende Deckung des Kontos zum Fälligkeitsdatum zu sorgen. Im Falle einer Rücklastschrift aufgrund Verschuldens des Kunden hat der Kunde die
					anfallende Bank- und Bearbeitungsgebühren zu tragen.
				</p>
				<h3>
					§ 7 Eigentums- bzw. Rechtevorbehalt
				</h3>
				<p>
					Erstellte {translations.de_DE.words.appName} Reports bleiben bis zur vollständigen Bezahlung der vereinbarten Vergütung im Eigentum des Anbieters. Die entsprechenden
					Nutzungsrechte werden bis zur vollständigen Zahlung lediglich widerruflich gewährt.
				</p>
				<h3>
					§ 8 Dauer des Vertrages, Beendigung
				</h3>
				<p>
					(1) Der zwischen den Parteien geschlossene Nutzungsvertrag hat, soweit nicht anders vereinbart, eine Laufzeit von 12 Monaten. Danach verlängert er
					sich jeweils um weitere 12 Monate, soweit er nicht von einer der Parteien mit einer Frist von 3 Monaten zum Laufzeitende in Textform gekündigt wird.
				</p>
				<p>
					(2) Das Recht zur fristlosen Kündigung aus wichtigem Grund bleibt hiervon unberührt. Insbesondere hat der Anbieter ein außerordentliches
					Kündigungsrecht, soweit der Kunde mit fälligen Zahlungen nach Mahnung länger als 14 Tage in Verzug ist sowie bei Verstößen insbesondere gegen die
					Pflichten aus den Geschäftsbedingungen. Der Kunde ist bei einer außerordentlichen Kündigung durch den Anbieter zum Schadenersatz verpflichtet,
					sofern er die Gründe, die den Anbieter zur Kündigung berechtigen, zu vertreten hat.
				</p>
				<h3>
					§ 9 Folgen der Beendigung des Vertrages
				</h3>
				<p>
					Mit Beendigung des Vertragsverhältnisses endet das Zugriffs- und Nutzungsrecht für den {translations.de_DE.words.appName} Service. Der Kunde hat keinen Zugriff mehr auf
					sein Konto und die dort ggfs. archivierten {translations.de_DE.words.appName} Reports. Der Kunde sollte daher vor Ende der Vertragslaufzeit seine {translations.de_DE.words.appName} Reports
					herunterladen und lokal speichern.
				</p>
				<h3>
					§ 10 Datensicherung und Datenverfügbarkeit
				</h3>
				<p>
					Der Anbieter hält alle digitalen Daten, auch erstellte und im Kundenkonto archivierte {translations.de_DE.words.appName} Reports für eine angemessene Frist bei sich
					abrufbar. Eine unbefristete Datensicherung und Datenverfügbarkeit kann jedoch nicht gewährleistet werden. Der Kunde sollte daher seine Reports
					parallel lokal auf angeschlossenen Endgeräten speichern. Der Kunde wird ausdrücklich und mit angemessenem Vorlauf informiert, soweit {translations.de_DE.words.appName}
					durch den Anbieter zukünftig nicht mehr bereitgestellt werden können.
					Der Anbieter ist bemüht, die im Kundenkonto erstellten und archivierten {translations.de_DE.words.appName} Reports möglichst ununterbrochen verfügbar zu halten. Durch
					Wartungs- und Reparaturarbeiten sowie System-Aktualisierungen oder auch technische Störungen, die außerhalb des Einflussbereichs des Verkäufers
					liegen, kann die Verfügbarkeit möglicherweise eingeschränkt sein. Eine Gewährleistung für die jederzeitige Verfügbarkeit wird nicht übernommen.
				</p>
				<h3>
					§ 11 Haftung
				</h3>
				<p>
					(1) Der Anbieter haftet nicht für Schäden, die dem Kunden aufgrund der Verletzung von Obliegenheiten der Geschäftsbedingungen entstehen. Unbeschadet
					hiervon gelten die folgenden Absätze 2 bis 5.
				</p>
				<p>
					(2) Der Anbieter haftet uneingeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit, in allen Fällen des Vorsatzes,
					bei grober Fahrlässigkeit und in allen anderen gesetzlich geregelten Fällen.
				</p>
				<p>
					(3) Sofern wesentliche Vertragspflichten betroffen sind, ist die Haftung des Anbieters bei leichter Fahrlässigkeit auf den vertragstypischen,
					vorhersehbaren Schaden beschränkt; die Haftung für vertragsuntypische Schäden, Mangelfolgeschäden und entgangenen Gewinn ist ausgeschlossen.
					Wesentliche Vertragspflichten sind wesentliche Pflichten, die sich aus der Natur des Vertrages ergeben und deren Verletzung die Erreichung des
					Vertragszweckes gefährden würde sowie Pflichten, die der Vertrag dem Anbieter nach seinem Inhalt zur Erreichung des Vertragszwecks auferlegt, deren
					Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst möglich machen und auf deren Einhaltung der Kunde regelmäßig vertrauen darf.
				</p>
				<p>
					(4) Bei der Verletzung unwesentlicher Vertragspflichten ist die Haftung bei leicht fahrlässigen Pflichtverletzungen ausgeschlossen.
				</p>
				<p>
					(5) Die Datenkommunikation über das Internet kann nach dem derzeitigen Stand der Technik nicht fehlerfrei und/oder jederzeit verfügbar gewährleistet
					werden. Der Anbieter haftet insoweit nicht für die ständige und ununterbrochene Verfügbarkeit der Webseite und der dort angebotenen Dienstleistung.
					In diesem Zusammenhang gewährleistet der Anbieter eine durchschnittliche Erreichbarkeit seines Servers von 98% im Monatsmittel. Hiervon ausgenommen
					sind Zeiten, in denen der Server aufgrund von technischen oder sonstigen Problemen, die nicht im Einflussbereich des Anbieters liegen (höhere
					Gewalt, Stromausfälle, Verschulden Dritter etc.) nicht zu erreichen ist.
				</p>
				<p>
					(6) Die Datenkommunikation über das Internet kann nach dem derzeitigen Stand der Technik nicht fehlerfrei und/oder jederzeit verfügbar gewährleistet
					werden. Der Kunde ist daher selbst dafür verantwortlich die erstellten {translations.de_DE.words.appName} Reports unabhängig von der Verfügbarkeit des {translations.de_DE.words.appName} Service
					für sich verfügbar zu halten und dauerhaft zu archivieren. Der Anbieter haftet insoweit nicht für die ständige und ununterbrochene Verfügbarkeit der
					Services und für den etwaigen Datenverlust von im Kundenkonto erstellten und archivierten {translations.de_DE.words.appName} Reports.
				</p>
				<h3>
					§ 12 Abtretung
				</h3>
				<p>
					Eine Abtretung von Ansprüchen durch den Kunden aus dem mit dem Anbieter geschlossenen Vertrag ist ausgeschlossen.
				</p>
				<h3>
					§ 13 Rechtswahl, Gerichtsstand
				</h3>
				<p>
					Es gilt deutsches Recht. Handelt der Kunde als Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich- rechtliches Sondervermögen mit
					Sitz im Hoheitsgebiet der Bundesrepublik Deutschland, ist ausschließlicher Gerichtsstand für alle Streitigkeiten aus diesem Vertrag der
					Geschäftssitz des Anbieters. Hat der Kunde seinen Sitz außerhalb des Hoheitsgebiets der Bundesrepublik Deutschland, so ist der Geschäftssitz des
					Anbieters ausschließlicher Gerichtsstand für alle Streitigkeiten aus diesem Vertrag. Der Anbieter ist in den vorstehenden Fällen jedoch in jedem
					Fall berechtigt, das Gericht am Sitz des Kunden anzurufen.
				</p>
				<div className={"spacer"}/>
				<p className={"tRight"}>
					<em>
						Stand: <strong>1. Dezember 2018</strong>
					</em>
				</p>
		</React.Fragment>;
		
		return inline
			? data
			: <Page title={"Allgemeine Geschäftsbedingungen der Test GmbH"} pageUrl={"/agb"}>
				<div className={"col s12"}>{data}</div>
			</Page>;
		
	} // function render()
	
} // class

export default Agb;